const locale = {
    startsWith: 'Inizia con',
    contains: 'Contiene',
    notContains: 'Non contiene',
    endsWith: 'Termina con',
    equals: 'Uguale',
    notEquals: 'Diverso',
    noFilter: 'Nessun filtro',
    lt: 'Minore di',
    lte: 'Minore o uguale a',
    gt: 'Maggiore di',
    gte: 'Maggiore o uguale a',
    dateIs: 'La data è',
    dateIsNot: 'La data non è',
    dateBefore: 'La data è precedente',
    dateAfter: 'La data è successiva',
    clear: 'Svuota',
    apply: 'Applica',
    matchAll: 'Tutti',
    matchAny: 'Qualsiasi',
    addRule: 'Aggiungi Regola',
    removeRule: 'Rimuovi Regola',
    accept: 'Si',
    reject: 'No',
    choose: 'Scegli',
    upload: 'Carica',
    cancel: 'Annulla',
    dayNames: [
        'Domenica',
        'Lunedì',
        'Martedì',
        'Mercoledì',
        'Giovedì',
        'Venerdì',
        'Sabato'
    ],
    dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    monthNames: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre'
    ],
    monthNamesShort: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic'
    ],
    today: 'Oggi',
    weekHeader: 'Sett',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Debole',
    medium: 'Media',
    strong: 'Forte',
    passwordPrompt: 'Inserisci una password',
    emptyFilterMessage: 'Nessun risultato',
    emptyMessage: 'Nessuna opzione disponibile'
};

export default locale;
